// extracted by mini-css-extract-plugin
module.exports = {"disabled":"CustomLink_disabled__sXUAh"};